import { AgenciaDto } from "src/app/pagamento/models/agencia-dto";
import { BANCO_DTO } from "./banco-dto.mock";

const BANCO_MAPPING = {};

for (const banco of BANCO_DTO) {
  BANCO_MAPPING[banco.codigo] = banco;
}

export const AGENCIA_DTO: AgenciaDto[] = [
  { codigo: 1, nome: "MATRIZ", banco: BANCO_MAPPING[1] },
  { codigo: 2, nome: "MANAUS", banco: BANCO_MAPPING[1] },
  { codigo: 13, nome: "MACEIO", banco: BANCO_MAPPING[1] },
  { codigo: 1451, nome: "CORURIPE", banco: BANCO_MAPPING[1] },
  { codigo: 2504, nome: "RUA JOAO PESSOA - C GRANDE", banco: BANCO_MAPPING[1] },
  { codigo: 3216, nome: "SUDOESTE - BRASILIA - DF", banco: BANCO_MAPPING[1] },
  { codigo: 5034, nome: "EMPRESARIAL BRASILIA II (DF)", banco: BANCO_MAPPING[1] },
  { codigo: 5112, nome: "SETOR PUBLICO-RIO BRANCO(AC)", banco: BANCO_MAPPING[5] },
  { codigo: 5096, nome: "SETOR PUBLICO MACEIO(AL)", banco: BANCO_MAPPING[5] },
  { codigo: 5102, nome: "SETOR PUBLICO-MACAPA(AP)", banco: BANCO_MAPPING[5] },
  { codigo: 5098, nome: "SETOR PUBLICO-MANAUS(AM)", banco: BANCO_MAPPING[5] },
  { codigo: 5082, nome: "AGÊNCIA GOVERNO SALVADOR(BA)", banco: BANCO_MAPPING[5] },
  { codigo: 8, nome: "FORTALEZA(CE)", banco: BANCO_MAPPING[5] },
  { codigo: 4251, nome: "GOVERNO BRASILIA(DF)", banco: BANCO_MAPPING[5] },
  { codigo: 5087, nome: "SETOR PUBLICO VITORIA(ES)", banco: BANCO_MAPPING[5] },
  { codigo: 86, nome: "SETOR PUBLICO-GOIANIA(GO)", banco: BANCO_MAPPING[5] },
  { codigo: 5124, nome: "SETOR PUBLICO-SÃO LUIS(MA)", banco: BANCO_MAPPING[5] },
  { codigo: 5125, nome: "SETOR PUBLICO-CUIABÁ(MT)", banco: BANCO_MAPPING[5] },
  { codigo: 4816, nome: "SETOR PUBLICO-CAMPO GRANDE(MS)", banco: BANCO_MAPPING[5] },
  { codigo: 4336, nome: "GOVERNO-BELO HORIZONTE(MG)", banco: BANCO_MAPPING[5] },
  { codigo: 5899, nome: "ESTILO BELÉM(PA)", banco: BANCO_MAPPING[5] },
  { codigo: 4299, nome: "SETOR PUBLICO-JOÃO PESSOA(PB)", banco: BANCO_MAPPING[5] },
  { codigo: 7411, nome: "ESTILO CENTRO CÍVICO - CURITIBA(PR)", banco: BANCO_MAPPING[5] },
  { codigo: 5379, nome: "CHESF - RECIFE (PE)", banco: BANCO_MAPPING[5] },
  { codigo: 5113, nome: "SETOR PUBLICO -TERESINA(PI)", banco: BANCO_MAPPING[5] },
  { codigo: 4906, nome: "GOVERNO - RIO DE JANEIRO(RJ)", banco: BANCO_MAPPING[5] },
  { codigo: 5120, nome: "SETOR PUBLICO -NATAL(RN)", banco: BANCO_MAPPING[5] },
  { codigo: 3139, nome: "GOVERNO - PORTO ALEGRE(RS)", banco: BANCO_MAPPING[5] },
  { codigo: 5101, nome: "SETOR PUBLICO -PORTO VELHO(RO)", banco: BANCO_MAPPING[5] },
  { codigo: 5115, nome: "SETOR PUBLICO-BOA VISTA(RR)", banco: BANCO_MAPPING[5] },
  { codigo: 5111, nome: "SETOR PUBLICO-FLORIANÓPOLIS(SC)", banco: BANCO_MAPPING[5] },
  { codigo: 2885, nome: "GOVERNO - SAO PAULO (SP)", banco: BANCO_MAPPING[5] },
  { codigo: 5103, nome: "SETOR PUBLICO ARACAJU(SE)", banco: BANCO_MAPPING[5] },
  { codigo: 5099, nome: "SETOR PUBLICO -PALMAS(TO)", banco: BANCO_MAPPING[5] },
  { codigo: 1, nome: "CENTRAL", banco: BANCO_MAPPING[47] },
  { codigo: 534, nome: "RIO BRANCO/AC", banco: BANCO_MAPPING[104] },
  { codigo: 1020, nome: "CATEDRAL MACEIO/AL", banco: BANCO_MAPPING[104] },
  { codigo: 658, nome: "MACAPA/AP", banco: BANCO_MAPPING[104] },
  { codigo: 3990, nome: "PAB JUSTICA FEDERAL DE MANAUS/AM", banco: BANCO_MAPPING[104] },
  { codigo: 5142, nome: "AEROPORTO DE SALVADOR/BA", banco: BANCO_MAPPING[104] },
  { codigo: 4549, nome: "PA DIGITAL FORTALEZA/CE", banco: BANCO_MAPPING[104] },
  { codigo: 1399, nome: "AGÊNCIA TRT BRASÍLIA/DF", banco: BANCO_MAPPING[104] },
  { codigo: 3370, nome: "PAB PREFEITURA MUNICIPAL DE VITÓRIA/ES", banco: BANCO_MAPPING[104] },
  { codigo: 2079, nome: "GOIANIA/GO", banco: BANCO_MAPPING[104] },
  { codigo: 4289, nome: "LENÇÓIS MARANHENSES/MA", banco: BANCO_MAPPING[104] },
  { codigo: 2685, nome: "PA TRT - 23A REGIÃO_CUIABA/MT", banco: BANCO_MAPPING[104] },
  { codigo: 3953, nome: "PAB JUSTIÇA FEDERAL CAMPO GRANDE/MS", banco: BANCO_MAPPING[104] },
  { codigo: 621, nome: "PAB JUSTICA FEDERAL_BELO HORIZONTE/MG", banco: BANCO_MAPPING[104] },
  { codigo: 3260, nome: "AG.MARCO DE BELÉM/PA", banco: BANCO_MAPPING[104] },
  { codigo: 5839, nome: "PA DIGITAL JOAO PESSOA/PB", banco: BANCO_MAPPING[104] },
  { codigo: 1565, nome: "AGêNCIA CURITIBA/PR", banco: BANCO_MAPPING[104] },
  { codigo: 47, nome: "AEROPORTO RECIFE/PE", banco: BANCO_MAPPING[104] },
  { codigo: 2696, nome: "TRT TERESINA/PI", banco: BANCO_MAPPING[104] },
  { codigo: 2752, nome: "PREFEITURA DO RIO DE JANEIRO/RJ", banco: BANCO_MAPPING[104] },
  { codigo: 2502, nome: "PAB PREFEITURA MUNICIPAL NATAL/RN", banco: BANCO_MAPPING[104] },
  { codigo: 5433, nome: "PA PLATAFORMA GOVERNO PORTO ALEGRE/RS", banco: BANCO_MAPPING[104] },
  { codigo: 830, nome: "PAB JUSTICA FEDERAL PORTO VELHO/RO", banco: BANCO_MAPPING[104] },
  { codigo: 653, nome: "BOA VISTA/RR", banco: BANCO_MAPPING[104] },
  { codigo: 2370, nome: "JUSTIÇA FEDERAL FLORIANÓPOLIS/SC", banco: BANCO_MAPPING[104] },
  { codigo: 3009, nome: "CIDADE SÃO PAULO/SP", banco: BANCO_MAPPING[104] },
  { codigo: 2186, nome: "ARACAJU/SE", banco: BANCO_MAPPING[104] },
  { codigo: 2525, nome: "PALMAS/TO", banco: BANCO_MAPPING[104] },
  { codigo: 739, nome: "AGÊNCIA TOBIAS BARRETO/SE", banco: BANCO_MAPPING[104] },
  { codigo: 265, nome: "PAB JUSTICA FEDERAL", banco: BANCO_MAPPING[104] },
  { codigo: 3421, nome: "RIO BRANCO - URB RIO BRANCO, AC", banco: BANCO_MAPPING[237] },
  { codigo: 389, nome: "MACEIO-CENTRO, AL", banco: BANCO_MAPPING[237] },
  { codigo: 720, nome: "MACAPA, AP", banco: BANCO_MAPPING[237] },
  { codigo: 320, nome: "MANAUS, AM", banco: BANCO_MAPPING[237] },
  { codigo: 501, nome: "SALVADOR-CENTRO, BA", banco: BANCO_MAPPING[237] },
  { codigo: 452, nome: "FORTALEZA-CENTRO, CE", banco: BANCO_MAPPING[237] },
  { codigo: 565, nome: "BRASILIA-CENTRO, DF", banco: BANCO_MAPPING[237] },
  { codigo: 481, nome: "VITORIA CENTRO, ES", banco: BANCO_MAPPING[237] },
  { codigo: 87, nome: "GOIANIA, GO", banco: BANCO_MAPPING[237] },
  { codigo: 3797, nome: "PALÁCIO DOS LEÕES - URB SÃO LUIS, MA", banco: BANCO_MAPPING[237] },
  { codigo: 417, nome: "CUIABA, MT", banco: BANCO_MAPPING[237] },
  { codigo: 48, nome: "CAMPO GRANDE, MS", banco: BANCO_MAPPING[237] },
  { codigo: 461, nome: "BELO HORIZONTE-CENTRO, MG", banco: BANCO_MAPPING[237] },
  { codigo: 1014, nome: "BELEM, PA", banco: BANCO_MAPPING[237] },
  { codigo: 435, nome: "JOAO PESSOA, PB", banco: BANCO_MAPPING[237] },
  { codigo: 69, nome: "CURITIBA, PR", banco: BANCO_MAPPING[237] },
  { codigo: 597, nome: "AV MARQUES DE OLINDA URB RECIFE, PE", banco: BANCO_MAPPING[237] },
  { codigo: 405, nome: "TERESINA, PI", banco: BANCO_MAPPING[237] },
  { codigo: 213, nome: "RIO DE JANEIRO-CENTRO, RJ", banco: BANCO_MAPPING[237] },
  { codigo: 321, nome: "NATAL-CENTRO, RN", banco: BANCO_MAPPING[237] },
  { codigo: 194, nome: "PORTO ALEGRE CENTRO, RS", banco: BANCO_MAPPING[237] },
  { codigo: 432, nome: "PORTO VELHO, RO", banco: BANCO_MAPPING[237] },
  { codigo: 719, nome: "BOA VISTA, RR", banco: BANCO_MAPPING[237] },
  { codigo: 348, nome: "FLORIANOPOLIS, SC", banco: BANCO_MAPPING[237] },
  { codigo: 2449, nome: "SAO PAULO, SP", banco: BANCO_MAPPING[237] },
  { codigo: 123, nome: "JARAGUA", banco: BANCO_MAPPING[237] },
  { codigo: 1492, nome: "FLORESTA", banco: BANCO_MAPPING[237] },
  { codigo: 661, nome: "ARACAJU, SE", banco: BANCO_MAPPING[237] },
  { codigo: 429, nome: "PALMAS, TO", banco: BANCO_MAPPING[237] },
  { codigo: 767, nome: "RIO BRANCO, AC", banco: BANCO_MAPPING[341] },
  { codigo: 318, nome: "MACEIO, AL", banco: BANCO_MAPPING[341] },
  { codigo: 1055, nome: "MACAPA, AP", banco: BANCO_MAPPING[341] },
  { codigo: 576, nome: "MANAUS, AM", banco: BANCO_MAPPING[341] },
  { codigo: 204, nome: "SALVADOR, BA", banco: BANCO_MAPPING[341] },
  { codigo: 316, nome: "FORTALEZA, CE", banco: BANCO_MAPPING[341] },
  { codigo: 868, nome: "BRASILIA, DF", banco: BANCO_MAPPING[341] },
  { codigo: 322, nome: "VITORIA, ES", banco: BANCO_MAPPING[341] },
  { codigo: 231, nome: "GOIANIA, GO", banco: BANCO_MAPPING[341] },
  { codigo: 3603, nome: "SAO LUIS MARANHENSE, MA", banco: BANCO_MAPPING[341] },
  { codigo: 376, nome: "CUIABA, MT", banco: BANCO_MAPPING[341] },
  { codigo: 34, nome: "CAMPO GRANDE, MS", banco: BANCO_MAPPING[341] },
  { codigo: 1846, nome: "BELO HORIZONTE/ALEMG, MG", banco: BANCO_MAPPING[341] },
  { codigo: 309, nome: "BELEM, PA", banco: BANCO_MAPPING[341] },
  { codigo: 330, nome: "JOAO PESSOA, PB", banco: BANCO_MAPPING[341] },
  { codigo: 584, nome: "CURITIBA, PR", banco: BANCO_MAPPING[341] },
  { codigo: 338, nome: "RECIFE, PE", banco: BANCO_MAPPING[341] },
  { codigo: 4895, nome: "PERSONNALITE TERESINA, PI", banco: BANCO_MAPPING[341] },
  { codigo: 341, nome: "RIO RIO DE JANEIRO, RJ", banco: BANCO_MAPPING[341] },
  { codigo: 334, nome: "NATAL, RN", banco: BANCO_MAPPING[341] },
  { codigo: 951, nome: "PORTO ALEGRE, RS", banco: BANCO_MAPPING[341] },
  { codigo: 4741, nome: "PORTO VELHO GONCALVES DIAS, RO", banco: BANCO_MAPPING[341] },
  { codigo: 1157, nome: "BOA VISTA, RR", banco: BANCO_MAPPING[341] },
  { codigo: 391, nome: "FLORIANOPOLIS, SC", banco: BANCO_MAPPING[341] },
  { codigo: 1625, nome: "SAO PAULO JARDINS, SP", banco: BANCO_MAPPING[341] },
  { codigo: 369, nome: "ARACAJU, SE", banco: BANCO_MAPPING[341] },
  { codigo: 1482, nome: "PALMAS, TO", banco: BANCO_MAPPING[341] },
  { codigo: 1, nome: "PAULISTA", banco: BANCO_MAPPING[745] },
];